<template>
<div>
    
    <!-- <h5 class="text-center mb-4">ชื่อร้านค้า</h5> -->
    
    <div class="row justify-content-center mb-5">
        <div class="col col-lg-6 mm-2">
            <router-link :to="'/user/mangeshops/'+this.$route.params.id+'/view'" class="btn btn-1 btn-primary" active-class="active">
                <span class="btn-inner--icon">
                    <i class="ni ni-shop"></i>
                </span> หน้าแรก
            </router-link>

            <router-link :to="'/user/mangeshops/'+this.$route.params.id+'/transection'" class="btn btn-1 btn-primary" active-class="active">
                <span class="btn-inner--icon">
                    <i class="ni ni-bullet-list-67"></i>
                </span> ประวัติธุรกรรม
            </router-link>
            
            <router-link :to="'/user/mangeshops/'+this.$route.params.id+'/setting'" class="btn btn-1 btn-primary" active-class="active">
                <span class="btn-inner--icon">
                    <i class="ni ni-ui-04"></i>
                </span> ตั้งค่าร้านค้า
            </router-link>
        </div>
    </div>

</div>
</template>

<script>

export default {
  name: 'HeaderShop',
  components: {
    // HelloWorld
  }
}
</script>

<style>
    .mm-2 {
        margin-right: -2.4rem !important;
    }
</style>
